import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { Injectable } from '@angular/core';
import { globalStore } from '../../../../../modules/shared/shared.global-service';
import {
    selectCurrentServiceId,
    selectFolder,
    selectFolderId,
} from '../../../../../modules/content/store/person/person.selectors';

@Injectable()
export class ContinuousRecordCreateDialogStore extends ComponentStoreV2Factory {

    public folder = globalStore!.selectSignal(selectFolder);
    public folderId = globalStore!.selectSignal(selectFolderId);
    public serviceId = globalStore!.selectSignal(selectCurrentServiceId);

}
